@import "config";

.header {
	@include flex(row, space-between, center);

	width: 100%;
	margin-bottom: $spacing-stack-xxxs;

	& > h4 {
		text-transform: uppercase;
		color: rgba(0, 0, 0, 0.65);
		font-size: $font-size-xs;
		font-weight: $font-weight-bold;
	}
}
